<template>
  <div id="burger" :class="{ 'active' : isBurgerActive }" @click.prevent="toggle">
    <slot>
      <button type="button" class="burger-button" title="Menu">
        <img class='buger-button-img' :src="btn_bg_hm_nor"/>
        <img class='buger-button-img-closed' :src="btnBgHmClosed"/>
        <span class="hidden">Toggle menu</span>
        <!-- <span class="burger-bar burger-bar--1"><img class='buger-button-img' :src="btn_icon_hm_nor"/></span>
        <span class="burger-bar burger-bar--2"><img class='buger-button-img' :src="btn_icon_hm_nor"/></span>
        <span class="burger-bar burger-bar--3"><img class='buger-button-img' :src="btn_icon_hm_nor"/></span> -->
      </button>
    </slot>
  </div>
</template>
<script>
import { store, mutations } from '@/util/burger.js'
import btnBgHmNor from '@/assets/mobile/burger/mb_bar_menu_01.png'
import btnBgHmClosed from '@/assets/mobile/burger/mb_bar_closed_01.png'
import btnIconHmNor from '@/assets/mobile/burger/btn_icon_hm_nor.png'

export default {
  data () {
    return {
      btn_bg_hm_nor: btnBgHmNor,
      btnBgHmClosed,
      btn_icon_hm_nor: btnIconHmNor
    }
  },
  computed: {
    isBurgerActive () {
      return store.isNavOpen
    }
  },
  methods: {
    toggle () {
      mutations.toggleNav()
    }
  }
}
</script>
<style lang="scss">
.hidden {
  visibility: hidden;
}

button {
  cursor: pointer;
}

/* remove blue outline */
button:focus {
  outline: 0;
}

.burger-button {
  position: relative;
  top: 5px;
  // position: absolute;
  // top: 19px;
  // right: -10px;
  // height: 18px;
  height: 30px;
  width: 24px;
  display: block;
  z-index: 1000;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  // transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  // transform: rotate(360);
  transition-duration: 0.6s;
  transform-origin: center;
  .buger-button-img,
  .buger-button-img-closed {
    display: block;
    height: auto;
    z-index: 1000;
    // transition: opacity 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  .buger-button-img {
    opacity: 1;
  }
  .buger-button-img-closed {
    position: relative;
    // position: absolute;
    opacity: 0;
    // top: -1px;
    // right: 2px;
  }
}
.burger-bar {
  /* background-color: #130f40; */
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  /* height: 2px; */
  width: auto;
  margin-top: -3px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}

.burger-bar--2 {
  // transform-origin: 100% 50%;
  transform-origin: center;
  transform: scaleX(0.8);
}

.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}

.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}

.burger-bar--3 {
  transform: translateY(6px);
}

#burger.active .buger-button-img {
  opacity: 0;
}

#burger.active .buger-button-img-closed {
  opacity: 1;
}
#burger.active .burger-button {
  transform: rotate(-180deg);
}

/* #burger.active .burger-bar { */
  /* background-color: #fff; */
/* } */

#burger.active .burger-bar--1 {
  transform: rotate(45deg);
}

#burger.active .burger-bar--2 {
  opacity: 0;
}

#burger.active .burger-bar--3 {
  transform: rotate(-45deg);
}
</style>
